














import Vue from 'vue'
import { FilterItems } from '@/types/service-response'
import moment from 'moment'

interface ComponentData {
  selectedItem: string | undefined
  selectRules: Array<(v: string) => string | boolean>
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingYearSelect',

  props: {
    name: String,
    label: String,
    items: {
      type: Array as () => Array<FilterItems>
    },
    defaulValue: String,
    isRequired: Boolean,
    isValid: Boolean
  },

  data (): ComponentData {
    return {
      selectedItem: undefined,
      selectRules: [
        (v) => {
          if (this.isRequired) {
            return !!v || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ],
    }
  },

  computed: {
    yearItems () {
      let yearItems: Array<string> = []
      let currentYear = moment(new Date()).format('YYYY')
      if(this.items.length > 0) {
        yearItems = this.items.map((item: FilterItems) => {
          return item.FilterItemValue
        })
      } else {
        for (let i = parseInt(currentYear) - 1; i < parseInt(currentYear) + 3; i++) {
          yearItems.push(i.toString())
        }
      }
      return yearItems
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        form.validate()
      }
    }
  },

  methods: {

    onYearChange (): void {
      if (this.name && this.selectedItem) {
        let payload: Payload = { name: this.name, value: this.selectedItem, label: this.selectedItem }
        this.$emit('onYearChange', payload)
      }
    }
  },

  created () {
    if (this.defaulValue) {
      this.selectedItem = undefined
      this.selectedItem = this.defaulValue
      if (this.name && this.selectedItem) {
        let payload: Payload = { name: this.name, value: this.selectedItem, label: this.selectedItem }
        this.$emit('onYearChange', payload)
      }
    } else {
      this.selectedItem = moment(new Date()).format('YYYY')
      if (this.name && this.selectedItem) {
        let payload: Payload = { name: this.name, value: this.selectedItem, label: this.selectedItem }
        this.$emit('onYearChange', payload)
      }
    }
  }

})
